<div class="custom-modal">
  <div class="bloco-unico mb-3">
    <h3 class="uppercase">Remetentes</h3>
    <hr />
    <app-bloco-endereco-info-interno *ngFor="let remetentes of pedido?.remetente" [Tipo]="'Remetente:'"
      [RazaoSocial]="remetentes.remRazaoSocial" [Endereco]="remetentes.remEndereco" [Bairro]="remetentes.remBairro"
      [Cidade]="remetentes.remMunicipio" [UF]="remetentes.remUf" [CEP]="remetentes.remCEP" [CGC]="remetentes.remCGC"
      [InscricaoEstadual]="remetentes.remInscEstadual"></app-bloco-endereco-info-interno>
  </div>
  <div class="bloco-unico mb-3">
    <app-bloco-endereco-destinatario-interno [Tipo]="'Destinatário:'" [RazaoSocial]="pedido?.desRazaoSocial"
      [Endereco]="pedido?.desEndereco" [Bairro]="pedido?.desBairro" [Cidade]="pedido?.desMunicipio" [UF]="pedido?.desUF"
      [CEP]="pedido?.desCEP" [CGC]="pedido?.desCGC" [Telefone1]="pedido?.telefone" [Telefone2]="pedido?.telefone2"
      [Telefone3]="pedido?.telefone3"></app-bloco-endereco-destinatario-interno>
  </div>
  <hr />
</div>
